import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Maths({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M14.8 18H17.8M14.8 15H17.8M2.99999 12H21M15 7.49998H18M5.99999 7.49998H8.99999M7.49999 8.99998V5.99998M6.43999 15.44L8.55999 17.56M6.43999 17.56L8.55999 15.44M12 2.99998V21M21 18.652C21 19.942 19.94 20.992 18.65 20.992H5.33999C4.03999 20.992 2.98999 19.932 2.98999 18.642V5.32998C2.98999 4.02998 4.03999 2.97998 5.33799 2.97998H18.638C19.928 2.97998 20.978 4.02998 20.978 5.32798V18.628L21 18.652Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Maths;